import {
  Paper,
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ListAlt, ChevronRight } from '@mui/icons-material';
import ListTitleBox from '../../app/components/list/ListTitleBox';

export default function AdminPanel() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <ListTitleBox title={t('admin.panel.title')} />
      <Paper sx={{ width: '100%', mb: 1 }}>
        <List sx={{ p: 0 }}>
          <ListItem
            disablePadding
            secondaryAction={<ChevronRight sx={{ color: 'text.secondary' }} />}
          >
            <ListItemButton onClick={() => navigate('logs')}>
              <ListItemIcon>
                <ListAlt color="primary" />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {t('admin.panel.links.logs')}
                  </Typography>
                }
              />
            </ListItemButton>
          </ListItem>
        </List>
      </Paper>
    </>
  );
}
